import { BackImageBox } from './styles';
import backSrc from './resources/back.png';

export const BackImage = () => {
    return (
        <BackImageBox src={backSrc} />
    );
}
